import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { EquipmentPage } from '@/features/resources/equipment-page';

const searchSchema = z.object({
  tab: z.enum(['register', 'logs', 'utilisation']).optional().catch(undefined),
  equipment: z.string().optional().catch(undefined),
  defect: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/resources/equipment')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <EquipmentPage
      projectId={projectId}
      tab={search.tab}
      equipmentId={search.equipment}
      defectId={search.defect}
    />
  );
}
